
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","stroke":"none !important","xmlns":"http://www.w3.org/2000/svg","stroke-width":"0"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.183 10.836l-9.056-9.052-.607-.607a.738.738 0 00-1.041 0L.816 10.836a1.498 1.498 0 00-.44 1.078c.008.825.695 1.484 1.52 1.484h.996v7.633h16.214v-7.633h1.017a1.493 1.493 0 001.388-.928 1.49 1.49 0 00.113-.575c0-.398-.157-.775-.441-1.059zm-8.871 8.508H9.687v-4.781h2.625v4.78zm5.107-7.634v7.634h-3.607V14a.937.937 0 00-.938-.937h-3.75a.937.937 0 00-.937.937v5.344H4.58V11.71H2.33l8.672-8.665.541.542 8.128 8.123H17.42z","stroke":"none"}})])
          )
        }
      }
    